import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    errorMessage: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Error message shown when bulk visibility toggle fails */
            errorMessage: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "useBulkToggleShareVisibility.errorMessage?c=2wf1r6e9itmep", defaultMessage: "Something went wrong when updating the Share''s visibility" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
